import { Action } from 'redux';

export enum TAudioDevice {
  SET_AUDIO_DEVICE = 'SET_AUDIO_DEVICE',
  GET_AUDIO_DEVICES = 'GET_AUDIO_DEVICES',
  GET_AUDIO_DEVICES_SUCCESS = 'GET_AUDIO_DEVICES_SUCCESS',
  SET_AUDIO_DEVICE_SUCCESS = 'SET_AUDIO_DEVICE_SUCCESS',
}

export interface ISetAudioDevice extends Action {
  type: TAudioDevice.SET_AUDIO_DEVICE;
  payload: string;
}

export const ASetAudioDevice = (payload: string): ISetAudioDevice => ({ type: TAudioDevice.SET_AUDIO_DEVICE, payload });

export interface IGetAudioDevices extends Action {
  type: TAudioDevice.GET_AUDIO_DEVICES;
}

export const AGetAudioDevices = (): IGetAudioDevices => ({ type: TAudioDevice.GET_AUDIO_DEVICES });

export interface IGetAudioDevicesSuccess extends Action {
  type: TAudioDevice.GET_AUDIO_DEVICES_SUCCESS;
  payload: string[];
}

export const AGetAudioDevicesSuccess = (payload): IGetAudioDevicesSuccess => ({ type: TAudioDevice.GET_AUDIO_DEVICES_SUCCESS , payload });

export interface ISetAudioDeviceSuccess extends Action {
  type: TAudioDevice.SET_AUDIO_DEVICE_SUCCESS;
}

export const ASetAudioDeviceSuccess = (): ISetAudioDeviceSuccess => ({ type: TAudioDevice.SET_AUDIO_DEVICE_SUCCESS });
